import { render, staticRenderFns } from "./ManaDashboard.vue?vue&type=template&id=6db36fad&scoped=true&"
import script from "./ManaDashboard.vue?vue&type=script&lang=js&"
export * from "./ManaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManaDashboard.vue?vue&type=style&index=0&id=6db36fad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db36fad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
